const INFO = "info";
const WARNING = "warning";
const ERROR = "error";
const SUCCESS = "success";

export const notificationCodes = { INFO, WARNING, ERROR, SUCCESS };
